import { classes } from "./react"

interface Props {
    label?: React.ReactNode
    style?: React.CSSProperties
    labelStyle?: React.CSSProperties
    title?: string
    className?: string
    required?: boolean
    invalid?: boolean | string
}

export function FormGroup({ label, labelStyle, className, style, required, title, invalid, children }: React.PropsWithChildren<Props>) {

    className = classes(
        "form-group",
        className,
        required && "required",
        invalid && "invalid"
    )

    return <div className={className} style={style}>
        {(label != undefined) && <label title={title} style={labelStyle}>{label}</label>}
        {children}
    </div>

}
